import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import querySearch from "stringquery";
import WrappedRegistrationForm from "./RegisterForm";
import WithFormLayout from "../formLayout";
import { useSignupContext } from "../../../context/SignupContext";
import SummaryContainer from "../SummaryPanel/SummaryContainer";
import { updateSignupParams } from "../../../actions/signupActions";
import { GTM_pageview } from "../../../utils/googleTagManager";
import StepLayout from "../../layouts/stepLayout";
import { updateCart, fetchCart } from "../../../api/cartAPI";
import { useAppContext } from "../../../context/AppContext";
import { FEATURE_PROTECT_DOMAINS } from "../../../utils/constants";
import { updateOutbound, updateInbound, updateTransactional } from "../../../actions/appActions";

const RegisterPanel = props => {
    const {
        state: { signupParams, loading },
        dispatch: signupDispatch,
    } = useSignupContext();

    const {
        state: { inbound, outbound, transactional, loading: cartLoading},
        dispatch: appDispatch,
    } = useAppContext();

    useEffect(() => {
        GTM_pageview("New Account | MailChannels", "/pricing/signup");
    }, []);

    /**
     * track the url search params change,
     * if there are cart related params, update the cart
     * if there are no extra params, just fetch the cart
     */
    useEffect(() => {
        if (props.location && props.location.search) {
            const queryParams = querySearch(props.location.search);

            const {
                inboundHandle,
                inboundAllocation,
                inboundCoupon,
                outboundHandle,
                outboundCoupon,
                txHandle,
                txCoupon,
                token
            } = queryParams;

            //update cart
            let params = {};

            if (token) {
                params["token"] = token;
                params["query_string"] = props.location.search;
            }

            if (inboundHandle && inboundAllocation) {
                //inbound plan needs both handle and domains allocation
                params["inbound_plan"] = {
                    handle: inboundHandle,
                    features: {
                        [FEATURE_PROTECT_DOMAINS[0]]: inboundAllocation,
                    },
                };
                if (inboundCoupon) {
                    appDispatch(
                        updateInbound({
                            ...inbound,
                            coupons: [inboundCoupon],
                        })
                    );
                }
            }

            if (outboundHandle) {
                //outbound plan just need handle
                params["outbound_plan"] = {
                    handle: outboundHandle,
                };
                if (outboundCoupon) {
                    appDispatch(
                        updateOutbound({
                            ...outbound,
                            coupons: [outboundCoupon],
                        })
                    );
                }
            }

            if (txHandle) {
                params["transactional_plan"] = {
                    handle: txHandle,
                };
                if (txCoupon) {
                    appDispatch(
                        updateTransactional({
                            ...transactional,
                            coupons: [txCoupon],
                        })
                    );
                }
            }
            // has cart params, update cart
            // error has been handled in cartApi.js
            updateCart(params, appDispatch);
        } else {
            fetchCart(appDispatch); // no extra params, just fetch the cart
        }
    }, props.location);

    return (
        <StepLayout>
            <Helmet>
                <title>{`New Account | MailChannels`}</title>
            </Helmet>
            <WithFormLayout
                loading={Boolean(loading) || Boolean(cartLoading)}
                title={`Let's Get Started`}
                subTitle={`Review your plan and create an account.`}
                summary={<SummaryContainer showCoupon={true} />}
            >
                <WrappedRegistrationForm
                    signupParams={signupParams}
                    onFormsChange={params => signupDispatch(updateSignupParams(params))}
                />
            </WithFormLayout>
        </StepLayout>
    );
};

export default RegisterPanel;
